import React from 'react';
import { registerSuccessStep as registerLocales } from 'globals/locales/registration';
import FsAlertBoard from 'ui-elements/alerts/FsAlertBoard';
import { ReactComponent as SuccessIcon } from 'assets/images/billings-upgrade/upgrade-enterprise-send-success.svg';

const RegisterSuccessStep: React.FC = () => {
  return (
    <FsAlertBoard
      title={registerLocales.title}
      maxWidth={440}
      marginTop={4}
      icon={<SuccessIcon />}
    >
      {registerLocales.description}
    </FsAlertBoard>
  );
};

export default RegisterSuccessStep;
